import { Button, Card, Input, Layout, List, Modal, Space, Spin, message } from "antd";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../comps/pageHeader";
// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { addClassroom, fetchClassroomList, modifyClassroom } from "./classroomsSlice";
import { useNavigate } from "react-router-dom";

export default function ClassroomList({ pros }) {

    const dispatch = useDispatch();
    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookies] = useCookies();
    const navigate = useNavigate();

    // eslint-disable-next-line no-unused-vars
    const [fetchData, setFetchData] = useState({
        className: null,
        profId: null,
        page: 1,
        docsPerPage: 10,
    });

    const [addFormData, setAddFormData] = useState({
        email: null,
        className: null,
    });

    const [modifyFormData, setModifyFormData] = useState({
        id: null,
        profEmail: null,
        className: null,
    });

    // eslint-disable-next-line no-unused-vars
    const [selectedClassId, setSelectedClassId] = useState("");
    const [addClassModalOpen, setAddClassModalOpen] = useState(false);
    const [modifyClassModalOpen, setModifyClassModalOpen] = useState(false);

    const isFetchingClassroomList = useSelector((state) => state.classrooms.isFetchingClassroomList);
    const classroomList = useSelector((state) => state.classrooms.classroomList);
    const fetchProfileResult = useSelector((state) => state.dashboard.fetchProfileResult);
    const addClassroomResult = useSelector((state) => state.classrooms.addClassroomResult);
    const isAddingClassRoom = useSelector((state) => state.classrooms.isAddingClassroom);
    const modifyClassroomResult = useSelector((state) => state.classrooms.modifyClassroomResult);
    const isModifyingClassRoom = useSelector((state) => state.classrooms.isModifyingClassroom);

    useEffect(() => {
        dispatch(fetchClassroomList(cookies, fetchData));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData]);

    useEffect(() => {
        if (!selectedClassId) return;
        navigate(`/dashboard/classes/class/${selectedClassId}`);
        setSelectedClassId("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedClassId]);

    useEffect(() => {
        if (!addClassroomResult) return;

        setAddFormData({ email: null, className: null });
        setAddClassModalOpen(false);

        dispatch(fetchClassroomList(cookies, fetchData));

        message.success("Classe créée avec succès.");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addClassroomResult]);

    useEffect(() => {
        if (!modifyClassroomResult) return;

        setModifyFormData({ email: null, className: null });
        setModifyClassModalOpen(false);

        dispatch(fetchClassroomList(cookies, fetchData));

        message.success("Classe modifiée avec succès.");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modifyClassroomResult]);


    const onAddClassPressed = () => {
        dispatch(addClassroom(cookies, addFormData));
    }

    const onModifyClassPressed = () => {
        dispatch(modifyClassroom(cookies, modifyFormData));
    }

    const closeAddModal = () => {
        setAddClassModalOpen(false);
    }

    const closeModifyModal = () => {
        setModifyClassModalOpen(false);
    }

    return (
        <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
            <Layout>
                <PageHeader title="Vos classes" breadcrumbItems={["Vue d'ensemble", "Liste des classes"]} />
                <div style={{
                    margin: "2em",
                    padding: "2em 10vw 2em 10vw",
                    display: "flex",
                    direction: "column",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                }}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "40%" }}>
                        <h3 style={{ fontSize: "18px", color: "#00000073" }}>Codes Non Attribués</h3>
                        <h1 style={{ fontSize: "28px", width: "fit-content", margin: "5px 5px 5px 0px" }}>{fetchProfileResult?.unusedCodes ? fetchProfileResult.unusedCodes : 0}</h1>
                    </div>
                    <div style={{ display: "flex", marginLeft: "24px", marginRight: "24px", width: "40%", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <h3 style={{ fontSize: "18px", color: "#00000073" }}>Codes Activés</h3>
                        <h1 style={{ fontSize: "28px", margin: "5px 5px 5px 0px" }}>{fetchProfileResult?.allCodes ? fetchProfileResult.allCodes : 0}</h1>
                    </div>
                </div>
                <div
                    style={{
                        margin: "2em",
                        padding: "1em 2em 1em 2em",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#F5F5F5"
                    }}
                >
                    <List
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 2,
                            md: 4,
                            lg: 4,
                            xl: 6,
                            xxl: 3,
                        }}
                        loading={isFetchingClassroomList}
                        style={{ backgroundColor: "#F5F5F5" }}
                        dataSource={classroomList}
                        renderItem={(item) => (
                            <List.Item>
                                <Card
                                    style={{
                                        width: "fit-content",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center"
                                    }}
                                    title={item?.name}
                                >
                                    <p style={{ width: "10vw", marginBottom: "24px" }}>Nombre d'élèves {item.userCount}</p>
                                    <Button
                                        style={{ width: "100%" }}
                                        onClick={() => { setSelectedClassId(item?._id); }}
                                    >
                                        Voir
                                    </Button>
                                </Card>
                            </List.Item>
                        )}
                    />
                    {/* Add Modal */}
                    <Modal
                        title="Ajouter une classe"
                        open={addClassModalOpen}
                        cancelText="Annuler"
                        onCancel={closeAddModal}
                        okText={isAddingClassRoom ? <Spin /> : "Ajouter"}
                        onOk={onAddClassPressed}
                    >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <p style={{ margin: "12px 0px" }}>Nom de la classe</p>
                            <Input
                                placeholder="####"
                                value={addFormData.className}
                                onChange={(e) => { setAddFormData({ ...addFormData, className: e.target.value }) }}
                            />
                            <p style={{ margin: "12px 0px" }}>Prof attribué</p>
                            <Input
                                placeholder="prof.addresse@établissement.com"
                                value={addFormData.email}
                                onChange={(e) => { setAddFormData({ ...addFormData, email: e.target.value }) }}
                            />
                        </div>
                    </Modal>
                    {/* Edit Modal */}
                    <Modal
                        title="Modifier une classe"
                        open={modifyClassModalOpen}
                        cancelText="Annuler"
                        onCancel={closeModifyModal}
                        okText={isModifyingClassRoom ? <Spin /> : "Ajouter"}
                        onOk={onModifyClassPressed}
                    >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <p style={{ margin: "12px 0px" }}>Nom de la classe</p>
                            <Input
                                placeholder="####"
                                value={modifyFormData.className}
                                onChange={(e) => { setModifyFormData({ ...modifyFormData, className: e.target.value }) }}
                            />
                            <p style={{ margin: "12px 0px" }}>Prof attribué</p>
                            <Input
                                placeholder="prof.addresse@établissement.com"
                                value={modifyFormData.email}
                                onChange={(e) => { setModifyFormData({ ...modifyFormData, email: e.target.value }) }}
                            />
                        </div>
                    </Modal>
                </div>
            </Layout>

        </Space>
    );
}